import ListItemCollapsed from './list-item-collapsed';

export default ListItemCollapsed;